import React, { Fragment, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tabs } from 'antd';
import AnalyticsActions from '@Actions/application/analyticsActions';
import TabPane from 'antd/es/tabs/TabPane';
import ShopifyIntegrationActions from '@Actions/integrations/shopifyIntegrationActions';
import { GetShopifyErrors } from '../../modules/shopifyErrors';
import BulkUploadsList from './BulkUploadsList';
import ShopifyFailedEventsList from './ShopifyFailedEventsList';

import releaseConfig from "../../../config.json";
import { LoadingOutlined } from '@ant-design/icons';
import PRZText from '../Common/UI/PRZText';
import './style.scss';
/**
 *
 */
function BulkUpload({
  user,
  history,
}) {
  const [currentTab, setCurrentTab] = useState('/past-bulk-uploads');

  useEffect(() => {
    const params = new URLSearchParams(history.location.search);
    let key = params.get('tab');
    if (key) {
      setCurrentTab(key);
    } else {
      key = '/past-bulk-uploads';
      setCurrentTab('/past-bulk-uploads');
    }
    params.set('tab', key);
    history.push(`?${params.toString()}`);
  }, []);

  return (
    <Fragment>
      <div className="doc-list__wrapper">
        <div className="doc-list__tabs-wrapper">
          <Tabs
            activeKey={currentTab}
            onChange={(key) => {
              setCurrentTab(key);
              history.push(`?tab=${key}`);
            }}
            mode="horizontal"
          >
            <TabPane tab="Past Bulk Uploads" key="/past-bulk-uploads" />
            {!!user?.user_tenants?.filter((userTenant) => userTenant?.shopify_location_id)?.length && (<TabPane tab="Shopify Failed Events" key="/shopify-failed-events" />)}
          </Tabs>
        </div>
        {currentTab === '/past-bulk-uploads' && (
          <BulkUploadsList />
        )}
        {currentTab === '/shopify-failed-events' && (
          <ShopifyFailedEventsList />
        )}
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({ UserReducers }) => ({
  user: UserReducers.user,
});
const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BulkUpload));
